import { useState } from "react"
import {history} from 'umi';
export type ClickedRoute = {
  url: string;
  menuKey: string;
  pathname: string;
}

export default function headerContentTabList() {
  const [tabList, setTabList] = useState<ClickedRoute[]>([]);
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(-1);
  const closeTab=()=>{
    tabList.splice(currentTabIndex, 1);
    setTabList(tabList);
    history.goBack()
  }
  return {
    tabList,
    setTabList,
    currentTabIndex,
    closeTab,
    setCurrentTabIndex,
  }
}
